<template>
  <s-btn color="danger-white" icon="cog" :href :size="size">
    {{ $t('admin') }}
  </s-btn>
</template>
<script setup lang="ts">
import SBtn from '../design-system/SBtn.vue';

defineProps<{
  href: string;
  size?: 'sm' | 'md' | 'lg';
}>();
</script>
